import { useTranslation } from "react-i18next";
import { Error as ErrorIcon, Refresh } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import { IconButton } from "@/components/ui/icon-button";
import Text from "@/components/ui/text";

interface Props {
  onRetry: () => void;
  // While any answer is in flight a retry would overlap it.
  disabled?: boolean;
}

// Stands in for an answer Dreamer failed to give, under the question it failed on.
export default function ChatErrorCard({ onRetry, disabled = false }: Props) {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      className="flex flex-row items-center gap-4 w-full px-4 py-3 border border-border-badge-chip-default rounded-2xl"
      data-test="chat-error-card"
    >
      <IconContainer size="5" color="secondary">
        <ErrorIcon />
      </IconContainer>
      <Text variant="smBody" className="grow">
        {t("chat.answerFailed")}
      </Text>
      <IconButton
        variant="icon"
        size="lg"
        iconColor="secondary"
        onClick={onRetry}
        disabled={disabled}
        tooltipText={t("chat.tooltips.retry")}
        aria-label={t("chat.tooltips.retry")}
        data-test="chat-error-retry"
      >
        <Refresh />
      </IconButton>
    </div>
  );
}
